import React, { useMemo, useState, useEffect } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable, useRowSelect } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import config from "config.json";
import { CustomStyleColumn } from 'components/Types/GeneralTypes';
import { Checkbox } from 'components/Varios/Tabla/CheckBoxTable';
import { downloadExcelReport } from './FunctionsRegistroV';
import ButtonAprobarMasivo from 'components/Varios/ButtonAprobarMasivo';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import AnularSVG from "assets/icons/Permisos/anularXazul.svg"
import AprobarSVG from "assets/icons/Permisos/Visto.svg"

export default function TablaRegistroSolicitudesV2({ dataFilas, onClickVerDocumento, onClickRegistrar, onClickRechazar, onClickRegistroMasivo }) {
    const filas = useMemo(
        () => [...dataFilas], [dataFilas]
    )

    const [isLoading, setIsLoading] = useState(false);

    // Función para manejar la descarga del reporte y el estado de carga
    const handleDownloadReport = async () => {
        setIsLoading(true);
        try {
            await downloadExcelReport();
        } catch (error) {
            console.error('Error al generar el reporte:', error);
        } finally {
            setIsLoading(false);
        }
    };

    function GenerarCellDocumentos(data) {
        const iconoDescargarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Vista Previa Solicitud"
                onClick={() => onClickVerDocumento(data.documentos.refDoc)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Vista Previa Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const contentAccion = (
            <React.Fragment>
                {data.documentos.refDoc && iconoDescargarSolicitud}
            </React.Fragment>
        )
        return contentAccion
    }

    function GenerarCellAcciones(data) {
        const iconoRegistrarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Registrar Solicitud"
                onClick={() => onClickRegistrar(data.acciones)}
            >
                <img
                    src={AprobarSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Registrar Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Registrar Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const iconoAnularSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Rechazo Acción Personal"
                onClick={() => onClickRechazar(data.acciones)}
            >
                <img
                    src={AnularSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Rechazo Acción Personal"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Rechazo Acción Personal"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const contentAccion = (
            <React.Fragment>
                {iconoRegistrarSolicitud}
                {iconoAnularSolicitud}
            </React.Fragment>
        )
        return contentAccion
    }

    const columnas = React.useMemo(
        () => [

            {
                Header: 'Fecha Solicitud',
                accessor: 'fechaSolicitud',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: "Tipo de Solicitud",
                accessor: "tipoSolicitud"
            },
            {
                Header: 'Nombres',
                accessor: 'nombres',
            },
            {
                Header: 'Régimen',
                accessor: 'siglasRegimen',
            },
            {
                Header: 'Grado',
                accessor: 'grado',
            },
            {
                Header: 'RMU',
                accessor: 'rmu',
            },
            {
                Header: '# Partida',
                accessor: 'numeroPartida',
            },
            {
                Header: 'Fechas',
                id: 'fechas',
                accessor: row => ({
                    fechaInicio: row.fechaInicio,
                    fechaFin: row.fechaFin
                }),
                Cell: ({ value }) => {
                    const fechaDesde = ObtenerFechaFromIsoFormat(value.fechaInicio);
                    const fechaHasta = ObtenerFechaFromIsoFormat(value.fechaFin);
                    return (
                        <>
                            <div><strong>Desde: </strong>{fechaDesde}</div>
                            <div><strong>Hasta: </strong>{fechaHasta}</div>
                        </>
                    );
                }
            },
            {
                Header: '# Días',
                accessor: 'tiempo',
            },
            {
                Header: 'Observaciones',
                accessor: 'observacion',
            },
            {
                Header: "Documentos",
                accessor: (row) => ({
                    documentos: row,
                }),
                Cell: ({ value }) => GenerarCellDocumentos(value)
            },
            {
                Header: "Acciones",
                accessor: (row) => ({
                    acciones: row,
                }),
                Cell: ({ value }) => GenerarCellAcciones(value)
            },
        ], [dataFilas]
    )

    const columnasStyles = (cell) => [
        {
            HeaderName: "Estado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Acciones',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Documentos',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Semanas",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Unidad",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Solicitud",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fechas",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "# Días",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Régimen",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Grado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "RMU",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "# Partida",
            StyleHeader: {
                textAlign: "center"
            }
        }
    ]

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        selectedFlatRows,
        visibleColumns,
        prepareRow,
        state,
        setGlobalFilter
    } = useTable(
        {
            columns: columnas,
            data: filas,
            initialState: {
                pageSize: filas.length  // Mostrar todas las filas SOLO aquí
            },
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [
                    ...columns,
                    {
                        id: 'selection',
                        Header: ({ getToggleAllPageRowsSelectedProps }) => (
                            <Checkbox
                                isHeader={true}
                                {...getToggleAllPageRowsSelectedProps()}
                            />
                        ),
                        Cell: ({ row }) => (
                            <Checkbox
                                condition={ShowCheckBoxCondition(row.values)}
                                {...row.getToggleRowSelectedProps()}

                            />
                        )
                    }
                ]
            })
        }
    )

    // Opcional: Si necesitas resetear a "Mostrar Todas" después de ciertas acciones
    useEffect(() => {
        setPageSize(filas.length);
    }, [filas.length, setPageSize]);

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = filas.length;

    function ShowCheckBoxCondition(dataRow) {
        return dataRow;
    }

    const ButtonRegistroMasivo = useMemo(() => {

        const nombreBotonNotificarMasivo = "Registrar todas las acciones de personal seleccionadas";
        if (selectedFlatRows.length === 1) {
            var filaSeleccionada = selectedFlatRows[0].original;
            return <ButtonAprobarMasivo
                onClick={() => onClickRegistrar(filaSeleccionada)}
                text="Registrar Acción de Personal"
            />
        }
        else if (selectedFlatRows.length > 1) {
            var filasSeleccionadas = selectedFlatRows;
            var filasMapeadas = [];
            filasSeleccionadas.forEach(element => {
                filasMapeadas.push(element.original);
            });
            if (filasSeleccionadas.length > 1) {
                return <ButtonAprobarMasivo
                    onClick={() => onClickRegistroMasivo(filasMapeadas)}
                    text={nombreBotonNotificarMasivo}
                />
            }
            else if (filasSeleccionadas.length < 0) {
                return <ButtonAprobarMasivo
                    disabled
                    text="Registrar Acción de Personal"
                />
            }
        }
        else {
            return <ButtonAprobarMasivo
                disabled
                text="Registrar Acción de Personal"
            />
        }
    }, [selectedFlatRows])

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <div className="containerBtnAprobacionesVacLic">
                        <GlobalFilterTable
                            filter={globalFilter}
                            setFilter={setGlobalFilter}
                        />
                        <div className='containerBotonGenerarReporte'>
                            <ButtonAprobarMasivo
                                onClick={handleDownloadReport}
                                text={isLoading ? "Cargando..." : "GENERAR REPORTE"}
                                disabled={isLoading}
                            />
                        </div>
                        {ButtonRegistroMasivo}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}